import axios from "axios";

import { Message } from "element-ui";
// import { Message, MessageBox } from "element-ui";
// import loginPlugins from '../components/common/loginPlugins'
import store from "../store/index";
import router from "../router/index";
import { prefix } from "./env";
const service = axios.create({
  // process.env.NODE_ENV === 'development' 来判断是否开发环境
  timeout: 20000,
});

service.interceptors.request.use(
  (config) => {
    // 下面会说在什么时候存储 token
    let userPrefix = `${prefix}user`;
    if (localStorage[userPrefix]) {
      config.headers.Authorization =
        "Bearer " + JSON.parse(localStorage[userPrefix]).token;
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject();
  }
);

service.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      if (response.data.error_code === 4004) {
        // window.localStorage.removeItem('gx_zhihui_user');
        if (!store.state.wxLogin.status) {
          // loginPlugins.install();//弹窗登录框
          // MessageBox.alert('您的授权已过期，请重新登录？', '提示', {
          //     confirmButtonText: '确定',
          //     callback: () => {
          //         store.commit("LOGIN_INSERT", true);
          //         store.commit('USER_SIGNOUT');
          //         router.push({
          //             path:'/login'
          //         })
          //     }
          // })
          Message.error({ message: "您的授权已过期，请重新登录" });
          store.commit("LOGIN_INSERT", true);
          store.commit("USER_SIGNOUT");
          router.push({
            path: "/login",
          });
          return false;
        }
        return false;
      }
      return response.data;
    } else {
      Promise.reject();
    }
  },
  (err) => {
    if (err && err.response) {
      console.log(err.response.status);
      if (err.response.status == 401 || err.response.status == 403) {
        // MessageBox.alert('您的授权已过期，是否重新登录？', '提示', {
        //     confirmButtonText: '确定',
        //     callback: () => {
        //         router.push({
        //             path:'/login',
        //             query:{redirect:window.location.href}
        //         })
        //         return false;
        //     }
        // })
        // return false;
      }
      switch (err.response.status) {
        case 422:
          err.message = err.response.data;
          break;
        case 400:
          err.message = "请求错误(400)";
          break;
        case 401:
          err.message = "未授权，请重新登录(401)";
          break;
        case 403:
          err.message = "拒绝访问(403)";
          break;
        case 404:
          err.message = "请求出错(404)";
          break;
        case 405:
          err.message = `${err.response.data.message}`;
          break;
        case 408:
          err.message = "请求超时(408)";
          break;
        case 500:
          err.message = "网络错误(500)";
          break;
        case 501:
          err.message = "服务未实现(501)";
          break;
        case 502:
          err.message = "网络错误(502)";
          break;
        case 503:
          err.message = "服务不可用(503)";
          break;
        case 504:
          err.message = "网络超时(504)";
          break;
        case 505:
          err.message = "HTTP版本不受支持(505)";
          break;
        default:
          err.message = `连接出错(${err.response.status})!`;
      }
    } else {
      err.message = "连接服务器失败!";
    }
    Message.error({ message: err.message });
    return Promise.reject();
  }
);

export default service;
